import {NgModule} from '@angular/core';
import {TooltipComponent} from './components/tooltip.component';
import {CommonModule} from '@angular/common';
import {PopupModule} from '@progress/kendo-angular-popup';
import {TranslateModule} from '../translate/translate.module';
import {ClickOutModule} from '../directives/click.out/click.out.module';

@NgModule({
  declarations: [
    TooltipComponent
  ],
  exports: [
    TooltipComponent
  ],
  imports: [
    CommonModule,
    PopupModule,
    TranslateModule,
    ClickOutModule
  ]
})
export class TooltipModule { }
